/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ඊයේ",
        "-2": "පෙරේදා",
        "0": "අද",
        "1": "හෙට",
        "2": "අනිද්දා",
        "future": {
          "one": "දින {0}න්",
          "other": "දින {0}න්"
        },
        "past": {
          "one": "දින {0}කට පෙර",
          "other": "දින {0}කට පෙර"
        }
      },
      "day-narrow": {
        "-1": "ඊයේ",
        "-2": "පෙරේදා",
        "0": "අද",
        "1": "හෙට",
        "2": "අනිද්දා",
        "future": {
          "one": "දින {0}න්",
          "other": "දින {0}න්"
        },
        "past": {
          "one": "දින {0}කට පෙර",
          "other": "දින {0}කට පෙර"
        }
      },
      "day-short": {
        "-1": "ඊයේ",
        "-2": "පෙරේදා",
        "0": "අද",
        "1": "හෙට",
        "2": "අනිද්දා",
        "future": {
          "one": "දින {0}න්",
          "other": "දින {0}න්"
        },
        "past": {
          "one": "දින {0}කට පෙර",
          "other": "දින {0}කට පෙර"
        }
      },
      "hour": {
        "0": "මෙම පැය",
        "future": {
          "one": "පැය {0}කින්",
          "other": "පැය {0}කින්"
        },
        "past": {
          "one": "පැය {0}කට පෙර",
          "other": "පැය {0}කට පෙර"
        }
      },
      "hour-narrow": {
        "0": "මෙම පැය",
        "future": {
          "one": "පැය {0}කින්",
          "other": "පැය {0}කින්"
        },
        "past": {
          "one": "පැය {0}කට පෙර",
          "other": "පැය {0}කට පෙර"
        }
      },
      "hour-short": {
        "0": "මෙම පැය",
        "future": {
          "one": "පැය {0}කින්",
          "other": "පැය {0}කින්"
        },
        "past": {
          "one": "පැය {0}කට පෙර",
          "other": "පැය {0}කට පෙර"
        }
      },
      "minute": {
        "0": "මෙම මිනිත්තුව",
        "future": {
          "one": "මිනිත්තු {0}කින්",
          "other": "මිනිත්තු {0}කින්"
        },
        "past": {
          "one": "මිනිත්තු {0}කට පෙර",
          "other": "මිනිත්තු {0}කට පෙර"
        }
      },
      "minute-narrow": {
        "0": "මෙම මිනිත්තුව",
        "future": {
          "one": "මිනිත්තු {0}කින්",
          "other": "මිනිත්තු {0}කින්"
        },
        "past": {
          "one": "මිනිත්තු {0}කට පෙර",
          "other": "මිනිත්තු {0}කට පෙර"
        }
      },
      "minute-short": {
        "0": "මෙම මිනිත්තුව",
        "future": {
          "one": "මිනිත්තු {0}කින්",
          "other": "මිනිත්තු {0}කින්"
        },
        "past": {
          "one": "මිනිත්තු {0}කට පෙර",
          "other": "මිනිත්තු {0}කට පෙර"
        }
      },
      "month": {
        "-1": "පසුගිය මාසය",
        "0": "මෙම මාසය",
        "1": "ඊළඟ මාසය",
        "future": {
          "one": "මාස {0}කින්",
          "other": "මාස {0}කින්"
        },
        "past": {
          "one": "මාස {0}කට පෙර",
          "other": "මාස {0}කට පෙර"
        }
      },
      "month-narrow": {
        "-1": "පසුගිය මාස.",
        "0": "මෙම මාස.",
        "1": "ඊළඟ මාස.",
        "future": {
          "one": "මාස {0}කින්",
          "other": "මාස {0}කින්"
        },
        "past": {
          "one": "මාස {0}කට පෙර",
          "other": "මාස {0}කට පෙර"
        }
      },
      "month-short": {
        "-1": "පසුගිය මාස.",
        "0": "මෙම මාස.",
        "1": "ඊළඟ මාස.",
        "future": {
          "one": "මාස {0}කින්",
          "other": "මාස {0}කින්"
        },
        "past": {
          "one": "මාස {0}කට පෙර",
          "other": "මාස {0}කට පෙර"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "පසුගිය කාර්තුව",
        "0": "මෙම කාර්තුව",
        "1": "ඊළඟ කාර්තුව",
        "future": {
          "one": "කාර්තු {0}කින්",
          "other": "කාර්තු {0}කින්"
        },
        "past": {
          "one": "කාර්තු {0}කට පෙර",
          "other": "කාර්තු {0}කට පෙර"
        }
      },
      "quarter-narrow": {
        "-1": "පසුගිය කාර්.",
        "0": "මෙම කාර්.",
        "1": "ඊළඟ කාර්.",
        "future": {
          "one": "කාර්. {0}කින්",
          "other": "කාර්. {0}කින්"
        },
        "past": {
          "one": "කාර්. {0}කට පෙර",
          "other": "කාර්. {0}කට පෙර"
        }
      },
      "quarter-short": {
        "-1": "පසුගිය කාර්.",
        "0": "මෙම කාර්.",
        "1": "ඊළඟ කාර්.",
        "future": {
          "one": "කාර්. {0}කින්",
          "other": "කාර්. {0}කින්"
        },
        "past": {
          "one": "කාර්. {0}කට පෙර",
          "other": "කාර්. {0}කට පෙර"
        }
      },
      "second": {
        "0": "දැන්",
        "future": {
          "one": "තත්පර {0}කින්",
          "other": "තත්පර {0}කින්"
        },
        "past": {
          "one": "තත්පර {0}කට පෙර",
          "other": "තත්පර {0}කට පෙර"
        }
      },
      "second-narrow": {
        "0": "දැන්",
        "future": {
          "one": "තත්පර {0}කින්",
          "other": "තත්පර {0}කින්"
        },
        "past": {
          "one": "තත්පර {0}කට පෙර",
          "other": "තත්පර {0}කට පෙර"
        }
      },
      "second-short": {
        "0": "දැන්",
        "future": {
          "one": "තත්පර {0}කින්",
          "other": "තත්පර {0}කින්"
        },
        "past": {
          "one": "තත්පර {0}කට පෙර",
          "other": "තත්පර {0}කට පෙර"
        }
      },
      "week": {
        "-1": "පසුගිය සතිය",
        "0": "මෙම සතිය",
        "1": "ඊළඟ සතිය",
        "future": {
          "one": "සති {0}කින්",
          "other": "සති {0}කින්"
        },
        "past": {
          "one": "සති {0}කට පෙර",
          "other": "සති {0}කට පෙර"
        }
      },
      "week-narrow": {
        "-1": "පසුගිය සති.",
        "0": "මෙම සති.",
        "1": "ඊළඟ සති.",
        "future": {
          "one": "සති {0}කින්",
          "other": "සති {0}කින්"
        },
        "past": {
          "one": "සති {0}කට පෙර",
          "other": "සති {0}කට පෙර"
        }
      },
      "week-short": {
        "-1": "පසුගිය සති.",
        "0": "මෙම සති.",
        "1": "ඊළඟ සති.",
        "future": {
          "one": "සති {0}කින්",
          "other": "සති {0}කින්"
        },
        "past": {
          "one": "සති {0}කට පෙර",
          "other": "සති {0}කට පෙර"
        }
      },
      "year": {
        "-1": "පසුගිය වසර",
        "0": "මෙම වසර",
        "1": "ඊළඟ වසර",
        "future": {
          "one": "වසර {0}කින්",
          "other": "වසර {0}කින්"
        },
        "past": {
          "one": "වසර {0}කට පෙර",
          "other": "වසර {0}කට පෙර"
        }
      },
      "year-narrow": {
        "-1": "පසුගිය වසර",
        "0": "මෙම වසර",
        "1": "ඊළඟ වසර",
        "future": {
          "one": "වසර {0}කින්",
          "other": "වසර {0}කින්"
        },
        "past": {
          "one": "වසර {0}කට පෙර",
          "other": "වසර {0}කට පෙර"
        }
      },
      "year-short": {
        "-1": "පසුගිය වසර",
        "0": "මෙම වසර",
        "1": "ඊළඟ වසර",
        "future": {
          "one": "වසර {0}කින්",
          "other": "වසර {0}කින්"
        },
        "past": {
          "one": "වසර {0}කට පෙර",
          "other": "වසර {0}කට පෙර"
        }
      }
    },
    "locale": "si"
  });
}